<div id="image-upload-modal-root" *transloco="let t">
  <app-header>
    {{t(modalTitle)}}
    <app-icon-click (click)="onFailClick()" flat>{{'close'}}</app-icon-click>
  </app-header>
  <div class="image-upload-content">
    <input
      #fileInput
      id="fileInput"
      type="file"
      (change)="cropper.selectInputEvent($event)"
      accept="image/*"
      hidden>
    <ly-img-cropper
      #cropper
      id="image-cropper"
      [config]="initConfig"
      [(scale)]="scale"
      (minScale)="minScale = $event"
      (ready)="ready = true"
      (cleaned)="ready = false"
      (cropped)="onCropped($event)"
      (loaded)="onLoaded($event)"
      (error)="onError($event)">
      <div class="drop-container">
        <app-circle (click)="fileInput.click()">
          {{'file_upload'}}
        </app-circle>
        <span>
          {{t('drop-an-image')}}
          <app-anchor class="file-input"
                      (click)="fileInput.click()">
                      {{t('upload-file')}}
          </app-anchor>
        </span>
      </div>
    </ly-img-cropper>
    <app-label isError *ngIf="imageError">
      {{t(errorMessageKey)}}
    </app-label>
    <div *ngIf="ready" class="slider-container">
      <span>{{t('click-drag-image')}}</span>
      <div class="slide-bar">
        <app-icon-click mat-raised-button id="remove-zoom" (click)="cropper.zoomOut()">
          {{'remove'}}
        </app-icon-click>
        <ly-slider
          [thumbVisible]="false"
          [min]="minScale"
          [max]="1"
          [(ngModel)]="scale"
          (input)="onSliderInput($event)"
          step="0.000001"
        ></ly-slider>
        <app-icon-click mat-raised-button id="add-zoom" (click)="cropper.zoomIn()">
          {{'add'}}
        </app-icon-click>
      </div>
      <app-anchor class="file-input"
                  (click)="fileInput.click()">
                  {{t('upload-another-file')}}
      </app-anchor>
    </div>
    <div class="button-container">
      <app-primary-button mat-raised-button (clickAction)="onFailClick()" v2Outlined class="cancel">{{t('cancel')}}</app-primary-button>
      <app-primary-button *ngIf="ready" mat-raised-button (clickAction)="onSuccessClick()" v2Full class="change-image">{{t('change-image')}}</app-primary-button>
    </div>
  </div>
</div>
